export default string => string.replace(/(<([^>]+)>)/gi, '')
